import { createFileRoute } from "@tanstack/react-router";

import { projectTimelineQueryOptions } from "../projects/queries";
import { TimelineView } from "../projects/timeline/TimelineView";

export const Route = createFileRoute("/_auth/projects/$projectId/timeline")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      projectTimelineQueryOptions(params.projectId),
    ),
  component: TimelineRoute,
});

function TimelineRoute() {
  const { projectId } = Route.useParams();
  return <TimelineView projectId={projectId} />;
}
